import React, { useState } from 'react'
import { Container, Row, Col, Card } from "react-bootstrap";
import CategorySection from '../components/CategorySection';
import Footer from '../components/Footer';
import consumer from "../images/consumer-wrapper.webp"
import pro from "../images/professional.webp"
import CustomCursor from '../components/CustomCursor';
import pcb from "../images/mainpc.jpg";
import smart from "../images/smartlighting.jpeg";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import sun from "../images/sun.png"
import design from "../images/idea.png"
import power from "../images/thunderbolt.png"
import quality from "../images/quality.png"

function ProductDetail() {

  const categories = [
    { name: "Consumer", image: "consumer-bulb.jpg" },
    { name: "Professional", image: "professional-bulb.jpg" },
    { name: "PCB", image: "pcb-bulb.jpg" },
    // { name: "Smart Lighting", image: "smart-bulb.jpg" },
   
  ];
  
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    AOS.init({
      duration: 2000, // Animation speed (2 seconds)
      easing: "ease-in-out", // Smooth transition
      once: true, // Animation will play only once
    });
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation ka speed slow aur smooth
      easing: "ease-in-out", // Smooth effect
      once: true, // Sirf ek dafa animation chalega
    });
  }, []);

  return (
    <div className='product-detail-wrapper'>
      <CustomCursor/>
      <Container className="case-studies-section">
      <Row>
        <Col md={12} className="case-text">
          <motion.h1 className="title"
           initial={{ opacity: 0, y: 20 }}
           animate={{ opacity: 1, y: 0 }}
           transition={{ duration: 0.8 }}>
           </motion.h1>

          <motion.p className="description"
           initial={{ opacity: 0, y: 20 }}
           animate={{ opacity: 1, y: 0 }}
           transition={{ duration: 1 }}
          >
            At QH lighting, we bring innovation and brilliance to every space with our premium lighting 
            solutions. From energy efficient LED fixtures to elegant decorative lights, 
            our products combine cutting-edge technology with stunning design to enhance your home, office, or commercial space.
          </motion.p>
        </Col>
      </Row>
      </Container>
    <Container className="case-studies-section">
      <Row>
        <Col md={12} className="case-images">
          <Row>
            <Col md={3} className='mb-4' data-aos="fade-up" data-aos-duration="2000" data-aos-easing="ease-in-out">
              <a href="/consumer-product">
              <Card className="case-card">
                <Card.Img src={consumer} alt="Radisson Blu Resort" />
                <Card.Body>
                  <Card.Title className="case-title">
                    <a>Consumer</a>
                  </Card.Title>
                </Card.Body>
              </Card>
              </a>
            </Col>
            <Col md={3} className='mb-4'data-aos="fade-up" data-aos-duration="2000" data-aos-easing="ease-in-out" >
              <a href="/perfessional-product">
              <Card className="case-card">
                <Card.Img src={pro} alt="Smart Lighting Project" />
                <Card.Body>
                  <Card.Title className="case-title">
                   <a> Professional</a>
                    </Card.Title>
                </Card.Body>
              </Card>
              </a>
            </Col>    <Col md={3} className='mb-4'data-aos="fade-up" data-aos-duration="2000" data-aos-easing="ease-in-out" >
            <a href="/Ourproduct">
            <Card className="case-card">
                <Card.Img src={pcb} alt="Smart Lighting Project" />
                <Card.Body>
                  <Card.Title className="case-title">
                   <a>PCB</a>
                    </Card.Title>
                </Card.Body>
              </Card>
            </a>
          
            </Col>

            {/* <Col md={3} className='mb-4'data-aos="fade-up" data-aos-duration="2000" data-aos-easing="ease-in-out" >
             <a href='smartlighting'>
             <Card className="case-card">
                <Card.Img src={smart} alt="Smart Lighting Project" />
                <Card.Body>
                  <Card.Title className="case-title">
                   <a >Smart Lighting</a>
                    </Card.Title>
                </Card.Body>
              </Card>
             </a>
            </Col> */}
        
          </Row>
        </Col>
      </Row>
    </Container>

    {/* feactures */}
    <Container className="feature-section text-center">
      <Row className="justify-content-center feature-grid">
        <Col md={4} className="d-flex justify-content-center mb-4"  data-aos="fade-left">
          <Card className="feature-card cyan">
            <Card.Body>
              <Card.Title>Energy-Efficient & Eco-Friendly </Card.Title>
              <Card.Text>
               Save power without compromising brightness.
              </Card.Text>
              <img
                src={sun}
                alt="Supervisor"
                className="card-img"
              />
            </Card.Body>
          </Card>
        </Col>

        {/* Center Column (Two Stacked Cards) */}
        <Col md={4} className="center-col mb-4"  data-aos="fade-up" data-aos-delay="600">
          <Card className="feature-card red top-card mb-4">
            <Card.Body>
              <Card.Title>Stylish & Versatile Designs </Card.Title>
              <Card.Text>
                Perfect for modern and    classic interiors.
              </Card.Text>
              <img
                src={power}
                alt="Team Builder"
                className="card-img"
              />
            </Card.Body>
          </Card>
          <Card className="feature-card orange bottom-card" data-aos="fade-down" data-aos-delay="1000">
            <Card.Body>
              <Card.Title>Superior Quality & Durability </Card.Title>
              <Card.Text>
              Built to last with premium materials.
              </Card.Text>
              <img
                src={quality}
                alt="Calculator"
                className="card-img"
              />
            </Card.Body>
          </Card>
        </Col>

        {/* Right Card */}
        <Col md={4} className="d-flex justify-content-center mb-4"  data-aos="fade-right">
          <Card className="feature-card blue">
            <Card.Body>
              <Card.Title>Smart Lighting Options</Card.Title>
              <Card.Text>
              Control your ambiance with advanced technology.
              </Card.Text>
              <img
                src={design}
                alt="Karma"
                className="card-img"
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    <CategorySection/>
    {/* <Footer/> */}
    </div>
  )
}

export default ProductDetail